import VueApiPlugin from '@homeserve/vue-api-plugin';
import { default as Axios } from 'axios';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import sortBy from 'lodash/sortBy';
import moment from 'moment';
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import 'vuetify/src/stylus/app.styl';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

declare module 'vue/types/vue' {
  interface Vue {
    $vuetify: Vuetify;
    $messaging: firebase.messaging.Messaging;
  }
}

Vue.use(Vuetify, {
  theme: {
    primary: { base: '#e7342c' },
    secondary: { base: '#e7342d' },
    tertiary: { base: '#092c4f' },
  },
});

const http = Axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
});

http.interceptors.request.use(
  config => {
    // Do something before request is sent
    if (store.state.isAuthenticated && store.state.token) {
      config.headers.Authorization = `Bearer ${store.state.token}`;
    }
    return config;
  },
  error => {
    // Do something with request error
    Promise.reject(error);
  },
);

Vue.use(VueApiPlugin, { http });
Vue.filter('capitalize', (value: string) => {
  if (!value) {
    return '';
  }
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});
Vue.filter('meterToKilometer', meter => {
  if (!meter) {
    return 'n/a';
  }

  return `${(meter / 1000).toFixed(1)} km`;
});
Vue.filter('secondToHourMinute', second => {
  if (!second) {
    return 'n/a';
  }

  const duration = moment.duration(second, 'second');
  const hours = duration.hours();
  const minutes = duration.minutes();
  const output: string[] = [];

  if (hours > 0) {
    output.push(hours.toString());
    output.push('h');
  }

  if (minutes > 0) {
    output.push(minutes.toString());
    output.push('mn');
  }

  return output.join(' ');
});
Vue.filter('sort', (items, identity) => {
  return sortBy(items, identity);
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
